<template>
  <section class="te-bg-ordermade-cta px-5 py-20">
    <div class="co-container-sm">
      <h2 class="co-heading-2 text-center">
        まずは無料相談で<br class="block md:hidden">一歩を踏み出そう
      </h2>
      <!-- その1 -->
      <div class="mb-5 flex flex-col items-start gap-5 bg-co-gray-50 px-5 py-4 sm:flex-row">
        <img
          src="~/assets/images/Te/TeCourse/Ordermade/Cta/cta-photo-step.webp"
          width="239"
          height="154"
          loading="lazy"
          class="aspect-[3/2] w-full sm:w-44  md:w-60"
          alt="目標達成への一歩が迷いなく踏み出せる"
        >
        <div>
          <h3 class="co-display-10 mb-4 font-bold">
            目標達成への一歩が迷いなく踏み出せる
          </h3>
          <div class="text-co-gray-600">
            漠然とした不安や悩みを、カウンセラーが一緒に整理します。<br>相談を終える頃には、「これをすればいいんだ！」と次のステップが見えるはず。<br>まるで、迷路の出口を見つけたときのようなスッキリ感を味わえます！
          </div>
        </div>
      </div>
      <!-- その2 -->
      <div class="mb-10 flex flex-col items-start gap-5 bg-co-gray-50 px-5 py-4 sm:flex-row-reverse sm:justify-between">
        <img
          src="~/assets/images/Te/TeCourse/Ordermade/Cta/cta-photo-value.webp"
          width="239"
          height="154"
          loading="lazy"
          class="aspect-[3/2] w-full sm:w-44 md:w-60"
          alt="相談特典でお得に学習がはじめられる"
        >
        <div>
          <h3 class="co-display-10 mb-4 font-bold">
            相談特典でお得に学習がはじめられる
          </h3>
          <div class="text-co-gray-600">
            無料相談にご参加いただいた方には、感謝を込めた特別割引をご用意。<br>スキルアップへの第一歩を踏み出してみませんか？
          </div>
        </div>
      </div>
      <h3 class="co-display-8 mb-7 text-center font-bold leading-normal">
        無料相談参加者の声
      </h3>
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="1"
        :space-between="40"
        :breakpoints="{
          '576': {
            slidesPerView: 2,
          },
        }"
        :pagination="{
          clickable: true,
        }"
      >
        <SwiperSlide
          :key="1"
          class="!h-auto"
        >
          <div class="h-full rounded-lg bg-white px-5 py-4 text-co-gray-600">
            「こんなふうになれたらな」と漠然と感じていたことが、学習内容やスケジュールを具体的に示していただいたことで、「これならできそう…！」という期待に変わりました！
            <div class="co-display-13 mt-5 text-center">
              <img
                src="~/assets/images/Te/TeCourse/Ordermade/Cta/cta-voice-female-40.svg"
                width="56"
                height="56"
                class="mx-auto mb-2"
                alt="40代女性"
                loading="lazy"
              >
              40代女性
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="2"
          class="!h-auto"
        >
          <div class="h-full rounded-lg bg-white px-5 py-4 text-co-gray-600">
            学習目的や抱えている課題をしっかりと理解した上で、私のやりたいことや希望がいくつもある中で、市場価値の高いスキルを選んでいただいたおかげで、頭の中がスッキリ整理されました。
            <div class="co-display-13 mt-5 text-center">
              <img
                src="~/assets/images/Te/TeCourse/Ordermade/Cta/cta-voice-men-30.svg"
                width="56"
                height="56"
                class="mx-auto mb-2"
                alt="30代男性"
                loading="lazy"
              >
              30代男性
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="3"
          class="!h-auto"
        >
          <div class="h-full rounded-lg bg-white px-5 py-4 text-co-gray-600">
            「今の会社があっていないのかも」と転職を考えていましたが、頭の中を整理してもらえたことで、スキルを付けて現職で活かして、今の会社で評価されるようになろうと思いました！
            <div class="co-display-13 mt-5 text-center">
              <img
                src="~/assets/images/Te/TeCourse/Ordermade/Cta/cta-voice-female-30.svg"
                width="56"
                height="56"
                class="mx-auto mb-2"
                alt="30代女性"
                loading="lazy"
              >
              30代女性
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="4"
          class="!h-auto"
        >
          <div class="h-full rounded-lg bg-white px-5 py-4 text-co-gray-600">
            他のスクールでは実現できなかった要望を聞いてもらえました。何度も面談を重ねて細かく丁寧にヒアリングしてくれたので安心できました。
            <div class="co-display-13 mt-5 text-center">
              <img
                src="~/assets/images/Te/TeCourse/Ordermade/Cta/cta-voice-men-40.svg"
                width="56"
                height="56"
                class="mx-auto mb-2"
                alt="40代男性"
                loading="lazy"
              >
              40代男性
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <div class="mt-10 text-center">
        <a
          href="/counseling/htmlcss-schedule"
          class="bot_open co-btn-counseling rounded-full"
        >
          まずは相談してみる
          <i
            class="fa fa-angle-right ml-2"
            aria-hidden="true"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');

.te-bg-ordermade-cta {
  background: linear-gradient(90deg, #BEF0D2 0%, #E6FAE6 100%);
}

.te-cta-title {
  font-size: 1.125rem;
  @media (min-width: 768px) {
    font-size: 1.75rem;
  }
}

</style>
